import { createReducer, createAction, PayloadAction } from '@reduxjs/toolkit'

export type KurentoState = 'new' | 'connecting' | 'connected' | 'disconnected' | 'failed' | 'closed'

export interface KurrentoReducer {
  connectionState: KurentoState
  kurrentoMounted: boolean
}

const initialState: KurrentoReducer = {
  connectionState: 'new',
  kurrentoMounted: true
}

export interface KurentoConnectionState {
  connectionState: KurentoState
}

export type KurentoConnectionStateActionType = PayloadAction<KurentoConnectionState>
export const SET_KURENTO_CONNECTION_STATE = createAction<KurentoConnectionState>(
  'kurento_reducer/set_kurento_connection_state'
)
export const SET_KURENTO_MOUNTED = createAction<boolean>('kurento_reducer/set_kurento_mounted')

export const kurentoReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(SET_KURENTO_CONNECTION_STATE, (state, action) => {
      console.log('seting connection state', action.payload)
      return { ...state, connectionState: action.payload.connectionState }
    })
    .addCase(SET_KURENTO_MOUNTED, (state, action) => {
      return { ...state, kurrentoMounted: action.payload }
    })
})
